import store from '../store';

store.watch((state) => state["cart"]["basket"], async (value) => {
    console.log("watch: ", value)

    // get active cart
    await store.dispatch("cartData/computeCartData",{productList: value["productList"], changeBasket: true});
    await store.dispatch("cartData/getCost");

    const productList = store.getters["cartData/selectedProducts"];
    await store.dispatch("checkout/computeScheduleGroup", productList);
    await store.dispatch("checkout/getCost");
});